export const images=[
    // "https://sayyes.pk/wp-content/uploads/2019/12/node-java.jpg",
    "https://vaibhavraj.netlify.app/static/media/slide3.ef3d660a.jpg",
    // "https://vaibhavraj.netlify.app/static/media/slide2.61508ea8.jpeg",
    // "https://vaibhavraj.netlify.app/static/media/slide1.ce2fa051.jpeg",
]